import loadable from "@loadable/component";

export const AgentReferralPage = loadable(() => import("./AgentReferralPage"), {
  resolveComponent: mod => mod.AgentReferralPage,
});

export * from "./types";
